import { render, staticRenderFns } from "./ProductItemDesignSelector.vue?vue&type=template&id=e0c5da62&"
import script from "./ProductItemDesignSelector.vue?vue&type=script&lang=js&"
export * from "./ProductItemDesignSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports